import CompanyCondition from './Components/CompanyCondition'

const ready = (callback) => {
  if (document.readyState !== 'loading') callback()
  else document.addEventListener('DOMContentLoaded', callback)
}

ready(() => {
  CompanyCondition()
})
